import React from 'react';
import translate from '@/lib/intl/translate';
import { formatCurrency } from '@/utils/currency';

export default function GroupedStageTotals({
  askedAmount,
  expectedAmount,
  factoredAmount,
  wonAmount,
}: {
  askedAmount: number;
  expectedAmount: number;
  factoredAmount: number;
  wonAmount: number;
}) {
  return (
    <ul className="flex flex-col type-body3 sm:flex-row sm:gap-5">
      <li>
        {translate('OPPORTUNITIES_GROUP_BY_TOTAL_WON')}{' '}
        {formatCurrency(wonAmount, true)}
      </li>
      <li>
        {translate('OPPORTUNITIES_GROUP_BY_TOTAL_ASK')}{' '}
        {formatCurrency(askedAmount, true)}
      </li>
      <li>
        {translate('OPPORTUNITIES_GROUP_BY_TOTAL_EXPECTED')}{' '}
        {formatCurrency(expectedAmount, true)}
      </li>
      <li>
        {translate('OPPORTUNITIES_GROUP_BY_TOTAL_PROJECTED')}{' '}
        {formatCurrency(factoredAmount, true)}
      </li>
    </ul>
  );
}
